//Quick View



$(document).ready(function () {

  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {

    quickView();

  });


});



function quickView() {

  // $(".popup_btn").click(function () {
  $(document).on("click", ".popup_btn", function () {

    if ($('#popup_btn').length == 0){
      $("body").append('<div id="popup_btn"></div>');
      setTimeout(function(){ $('#popup_btn .color .bg_light-grey:eq(0)').addClass('active');}, 1000);

    }
    var product_handle = $(this).data('handle');

    $('#popup_btn').addClass(product_handle);

    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

      var title = product.title;

      var type = product.type;

      var price = 0;

      var original_price = 0;

      var desc = product.description;

      //var images = product.images;

      var images = product.media;

      var variants = product.variants;

      var options = product.options;

      var url = '/products/' + product_handle;

      $('.product_title').text(title);

      $('.qv-product-type').text(type);

      $('.pop_product_description').html(((desc)).substring(0,90));

      $('.view-product').attr('href', url);

      var imageCount = $(images).length;

      $(images).each(function (i, image) {

        var img_id= image.id;
        var scr=image.src;

        if (i == imageCount - 1) {

          var image_embed = '<div><img class="lazy2" src="' + scr + '"></div>';

          // image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');

          $('.pop_main_images ').append(image_embed);



          $('.pop_main_images ').slick({

            'dots': false,

            'arrows': true,

            'respondTo': 'min',

            'useTransform': false

          }).css('opacity', '1');

        } else {

          image_embed = '<div><img class="lazy2" src="' + scr + '"></div>';

          $('.pop_main_images ').append(image_embed);

        }

      });

      $(options).each(function (i, option) {

        var opt = option.name;

        var selectClass = '.option.' + opt.toLowerCase();

        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option h6 color_purple">' + opt + '</span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');

        $(option.values).each(function (i, value) {

          //           $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
          if(value.toLowerCase() == "white"){
            $('.option.' + opt.toLowerCase()).
            append('<input type="radio" class="input_radio" id="option-'+ opt.toLowerCase() + '-' +i +'" name="'+ opt.toLowerCase() +'" value="'+ value +'"><label  class=" h6 bg_light-grey custom_color color_white color_purple"  for="option-'+ opt.toLowerCase() + '-' +i +'" style="border: 1px solid #000 !important; position: relative; background-color:'+ value.toLowerCase().replace(' ','-') +';" name="'+ opt.toLowerCase() +'" value="'+ value +'">'+ value +'</label>');
          }
          else if(value.toLowerCase() == "purple"){
            $('.option.' + opt.toLowerCase()).
            append('<input type="radio" class="input_radio" id="option-'+ opt.toLowerCase() + '-' +i +'" name="'+ opt.toLowerCase() +'" value="'+ value +'"><label  class=" h6 bg_light-grey custom_color color_purple"  for="option-'+ opt.toLowerCase() + '-' +i +'" style="background-image:url(//cdn.shopify.com/s/files/1/0273/2995/3853/t/48/assets/'+ value.toLowerCase().replace(' ','-') +'.png); position: relative; background-color:#52539e;" name="'+ opt.toLowerCase() +'" value="'+ value +'">'+ value +'</label>');
        
          }else{
            $('.option.' + opt.toLowerCase()).
            append('<input type="radio" class="input_radio" id="option-'+ opt.toLowerCase() + '-' +i +'" name="'+ opt.toLowerCase() +'" value="'+ value +'"><label  class=" h6 bg_light-grey custom_color color_purple"  for="option-'+ opt.toLowerCase() + '-' +i +'" style="background-image:url(//cdn.shopify.com/s/files/1/0273/2995/3853/t/48/assets/'+ value.toLowerCase().replace(' ','-') +'.png); position: relative; background-color:'+ value.toLowerCase().replace(' ','-') +';" name="'+ opt.toLowerCase() +'" value="'+ value +'">'+ value +'</label>');
          }
        });

      });

      $(product.variants).each(function (i, v) {

        if (v.inventory_quantity == 0) {

          $('.pop_up_right_content').find('.pop_up_add_to_cart').prop('disabled', true).val('Sold Out');

          $('.pop_up_right_content').find('.qv-add-to-cart').hide();

          $('.pop_up_right_content').find('.pop_product_price').text('Sold Out').show();

          return true

        } else {

          price = parseFloat(v.price / 100).toFixed(2);

          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

          $('.pop_up_right_content').find('.pop_product_price').text('$' + price);

          if (original_price > 0) {

            $('.pop_up_right_content').find('.qv-product-original-price').text('$' + original_price).show();

          } else {

            $('.pop_up_right_content').find('.qv-product-original-price').hide();

          }

          //           $('select.option-0').val(v.option1);

          //           $('select.option-1').val(v.option2);

          //           $('select.option-2').val(v.option3);
          $('.option-0').find('input[type=radio][value="'+ v.option1 +'"]').prop('checked', true);
          $('.option-1').find('input[type=radio][value="'+ v.option2 +'"]').prop('checked', true);
          $('.option-2').find('input[type=radio][value="'+ v.option3 +'"]').prop('checked', true);

          return false

        }

      });




      $(product.variants).each(function (i, vid) {
        //  debugger;
        var id = vid.id;
        var title = vid.title;
        var price = vid.price;
        var img_src = vid.featured_image.src;

        $('.option-variant').append('<option value="' + title + '" data-id="'+id+'" data-media-src="'+img_src+'" data-price="'+price+'">' + title + '</option>');

      });





    });



    $(document).on("change", "#popup_btn input[type=radio]", function () {

      //alert("hi");

$('.qv-add-to-cart-response').removeClass('error').html('');
      

      var color = $(this).val();

      var size = $('.size input[type=radio]:checked').val();

      var variant = size +" / "+ color;

      // alert(variant);

      var size_dropdown = $(this).closest("div#popup_btn ").find(".qv-variant-options");

      if(!size){

        var select_option = $(size_dropdown).find("option").filter(function(){return $(this).val() == color});
      }else{

        var select_option = $(size_dropdown).find("option").filter(function(){return $(this).val() == variant});
      }

      if($(size_dropdown).length > 0){

        //alert($(size_dropdown).length);

        var image = $(select_option).attr('data-media-src');
        var price = parseFloat( $(select_option).attr('data-price')/ 100).toFixed(2);
        //$('.qv-product-price').text('$' + price);

        // alert(image);

        var slick_slide=$(this).closest("div#popup_btn").find(".pop_main_images .slick-list .slick-slide:not('.slick-cloned')");
        if($(slick_slide).length>0 ){

          var matched_image = $(slick_slide).filter(function(){return $(this).find("img").attr("src") == $(select_option).attr('data-media-src')});
          if(matched_image && matched_image.length > 0){
            //alert($(matched_image).attr('data-slick-index'));
            $('.pop_main_images').slick('slickGoTo', $(matched_image).attr('data-slick-index'));
          }

        }


      }




      var selectedOptions = '';

      $('#popup_btn .color input[type=radio]:checked').each(function (i) {


        if($(this).siblings('label[for='+$(this).attr("id")+']').hasClass("active")){
          $(this).siblings('label[for='+$(this).attr("id")+']').removeClass("active");
        }
        else{
          $(this).siblings('label.active').removeClass("active");
          $(this).siblings('label[for='+$(this).attr("id")+']').addClass("active");
        }


        if (selectedOptions == '') {

          selectedOptions = $(this).val();

        } else {

          selectedOptions = selectedOptions + ' / ' + $(this).val();

        }

      });

      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

        $(product.variants).each(function (i, v) {

          if (v.title == selectedOptions) {

            var price = parseFloat(v.price / 100).toFixed(2);

            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

            var v_qty = v.inventory_quantity;

            var v_inv = v.inventory_management;

            $('.pop_up_right_content').find('.pop_product_price').text('$' + price);

            $('.pop_up_right_content').find('.qv-product-original-price').text('$' + original_price);

            if (v_inv == null) {

              $('.pop_up_right_content').find('.pop_up_add_to_cart').prop('disabled', false).val('Add to Cart');

            } else {

              if (v.inventory_quantity < 1) {

                $('.pop_up_right_content').find('.pop_up_add_to_cart').prop('disabled', true).val('Sold Out');

              } else {

                $('.pop_up_right_content').find('.pop_up_add_to_cart').prop('disabled', false).val('Add to Cart');

              }

            }

          }

        });

      });

    });

    $.fancybox({

      href: '#popup_btn',

      maxWidth: 1040,

      maxHeight: 600,

      fitToView: true,

      width: '75%',

      height: '70%',

      autoSize: false,

      closeClick: false,

      openEffect: 'none',

      closeEffect: 'none',

      'beforeLoad': function () {

        var product_handle = $('#popup_btn').attr('class');

		
        $(document).on("click", ".pop_up_add_to_cart", function (event) {
          
			event.stopImmediatePropagation();
          
          var qty = $(this).parent('.pop_add_cart').prev('.quantity').find('.quantity__input').val();

          var selectedOptions = '';

          var var_id = '';

          $('#popup_btn input[type=radio]:checked').each(function (i) {

            if (selectedOptions == '') {

              selectedOptions = $(this).val();

            } else {

              selectedOptions = selectedOptions + ' / ' + $(this).val();

            }

          });

          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

            $(product.variants).each(function (i, v) {

              if (v.title == selectedOptions) {

                var_id = v.id;

                processCart();
				
              }

            });

          });

          function processCart() {

            jQuery.post('/cart/add.js', {

              quantity: qty,

              id: var_id

            },

                        null,

                        "json"

                       ).done(function () {
              $('.pop_up_add_to_cart').parents('.fancybox-outer').next('.fancybox-close').trigger('click');
              $('#cart-icon-bubble').trigger('click');
              

            })

            .fail(function ($xhr) {

              var data = $xhr.responseJSON;

              $('.qv-add-to-cart-response').addClass('error').html('<span>' + data.description);
              //$(".pop_up_add_to_cart").trigger('click');
               
			
            });

          }


        });


        //         $('.fancybox-wrap').css('overflow', 'hidden !important');

      },

      'afterShow': function () {

        $('#popup_btn').hide().html(content).css('opacity', '1').fadeIn(function () {

          $('.pop_main_images ').addClass('loaded');

        });

        $('<a href="#" class="pop_up_mobile_close_btn "><img  src="https://cdn.shopify.com/s/files/1/0273/2995/3853/files/Close_2.png?v=1639562447" /></a> ').prependTo( ".fancybox-skin" );
        $('body').addClass('pro_popup');
        $('.fancybox-skin').find('.fancybox-close').html('<img src="https://cdn.shopify.com/s/files/1/0273/2995/3853/files/Close-1.png?v=1639562032" class="pop_up_close_btn ">');

      },

      'afterClose': function () {

        $('#popup_btn').removeClass().empty();
        $('body').removeClass('pro_popup');
        
      }

    });

  });

  


};
        
  $(document).on("click", ".pop_up_mobile_close_btn", function(){
          $('body').find('.fancybox-opened, .fancybox-overlay').addClass('pc');
          $('body').removeClass('pro_popup');
        });

$(window).resize(function () {

  if ($('#popup_btn').is(':visible')) {

    $('.pop_main_images ').slick('setPosition');

  }

});


